import { gql } from '@apollo/client';
import {
  USER_BASIC_FIELDS,
  ID_NAME_FIELDS,
  PAGINATION_FIELDS,
  PROPERTY_MAIN_FIELDS,
} from 'graphql/common/fragments';

export const GET_DOCUMENT_CATEGORIES_QUERY = gql`
  query getDocumentCategories {
    documentCategories {
      ${ID_NAME_FIELDS}
    }
  }
`;

export const GET_DOCUMENTS_BY_SCOOP_QUERY = gql`
  query documents($scoopId: Int) {
    documents(scoopId: $scoopId) {
      id
      url
      createdAt
      name
      createdUser {
        ${USER_BASIC_FIELDS}
      }
      updatedUser {
        ${USER_BASIC_FIELDS}
      }
      category {
        ${ID_NAME_FIELDS}
      }
    }
  }
`;

export const SEARCH_DOCUMENTS_QUERY = gql`
  query documentSearch($search: DocumentSearchInput) {
    documentSearch(search: $search) {
      ${PAGINATION_FIELDS}
      results {
        id
        url
        name
        propertyId
        createdAt
        createdUser {
          ${USER_BASIC_FIELDS}
        }
        category {
          ${ID_NAME_FIELDS}
        }
        property {
          ${PROPERTY_MAIN_FIELDS}
          market {
            ${ID_NAME_FIELDS}
          }
          submarket {
            ${ID_NAME_FIELDS}
          }
          propertyType {
            ${ID_NAME_FIELDS}
          }
          propertyClass {
            ${ID_NAME_FIELDS}
          }
          propertySubtype {
            ${ID_NAME_FIELDS}
          }
          owners {
            ${ID_NAME_FIELDS}
          }
        }
      }
    }
  }
`;
